import type { FormEvent } from 'react'
import { useLanguage } from '../i18n'

export function Contact() {
  const { copy } = useLanguage()
  const whatsappMessage = encodeURIComponent('Olá, conheci a GeniusLEAD pelo site e gostaria de conversar.')

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    const body = [
      `Nome: ${data.get('name') ?? ''}`,
      `Empresa: ${data.get('company') ?? ''}`,
      `Contato: ${data.get('contact') ?? ''}`,
      `Mensagem: ${data.get('message') ?? ''}`,
    ].join('\n')

    window.location.href = `mailto:comercial@geniuslead.com.br?subject=${encodeURIComponent(copy.contact.emailSubject)}&body=${encodeURIComponent(body)}`
  }

  return (
    <section id="contato" className="section contact" aria-labelledby="contact-title">
      <div className="container contact-layout">
        <div>
          <span className="section-kicker">{copy.contact.kicker}</span>
          <h2 id="contact-title">{copy.contact.title}</h2>
        </div>
        <div className="contact__content">
          <p>{copy.contact.introduction}</p>
          <strong>{copy.contact.specialties}</strong>
          <a className="contact__email" href="mailto:comercial@geniuslead.com.br">comercial@geniuslead.com.br</a>
          <a className="contact__whatsapp" href={`https://wa.me/5515981151208?text=${whatsappMessage}`} target="_blank" rel="noopener noreferrer">{copy.contact.whatsapp}</a>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            <span>{copy.contact.fields.name}</span>
            <input type="text" name="name" autoComplete="name" required />
          </label>
          <label>
            <span>{copy.contact.fields.company}</span>
            <input type="text" name="company" autoComplete="organization" required />
          </label>
          <label>
            <span>{copy.contact.fields.contact}</span>
            <input type="text" name="contact" autoComplete="email" required />
          </label>
          <label className="contact-form__message">
            <span>{copy.contact.fields.message}</span>
            <textarea name="message" rows={4} required />
          </label>
          <button className="button button--light" type="submit">{copy.contact.submit}</button>
        </form>
      </div>
    </section>
  )
}
